<template>
    <v-dialog
      v-model="isOpen"
      width="650"
      @click:outside="closeModal"
    >
      <v-card class="d-flex flex-column align-items-center p-2">
        <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
        <v-card-title class="mb-4">Selecione um Animal</v-card-title>
        <v-card-text class="d-flex flex-column align-items-center">
          <v-autocomplete
            class="col-md-12"
            label="Pesquise por código ou por nome (Digite mais de 3 dígitos para pesquisar)"
            outlined
            item-text="name_code"
            item-value="id"
            :items="computedAnimals"
            return-object
            v-model="selected_animal"
            no-data-text="Nenhum resultado..."
            @update:search-input="searchAnimals"
            clearable
          ></v-autocomplete>
          
          <v-btn 
            @click="addAnimal"
            class="col-md-6 p-2"
            style="color:white; background-color:var(--jersey-yellow)"
            :disabled="animalDoesntHasBirth"
          >
            Adicionar o Animal
          </v-btn>
        </v-card-text>
      </v-card>
      <modal-doesnt-have-birth 
        :active="animalDoesntHasBirth"
        :animal="selected_animal"
        :service="service"
        @close="animalDoesntHasBirth = false"
      />
    </v-dialog>
</template>

<script>
import ModalDoesntHaveBirth from "./ModalDoesntHaveBirth.vue";
import { mapActions, mapMutations } from 'vuex';
export default {
  name:"ModalAddAnimals",
  props:{
    isOpen:Boolean,
    service:Object,
    alreadyIncluded:Array
  },
  components: {
    ModalDoesntHaveBirth
  },
  data() {
    return {
      selected_animal:null,
      animal_group:null,
      animals:[],
      animalDoesntHasBirth:false,
    }
  },
  computed: {
    computedAnimals() {
      const animals_list = this.animals.filter(e => /^f/i.test(e.gender || ""));
      return animals_list.map(e => ({...e, name_code:e.code + " - " + e.name + " - " + e.register, name:e.name}));
    }
  },
  methods: {
    ...mapActions("animals", ["actionSearchAnimalsGeneral"]),
    ...mapMutations("loader", ["SET_LOADER"]),
    //Esse metodo de validação é para não incluír o mesmo animal na tabela
    validations() {
      const finded = this.alreadyIncluded.find(e => e.animal_id === this.selected_animal.id);
      if(finded) {
        this.$toast.warning("Animal já está incluso");
        return false;
      } else {
        return true;
      }
    },
    //Esse metodo vai pesquisar os animais com o campo de busca
    async searchAnimals(data) {
      if(!data || !data.length) {
        this.selected_animal = null;
      }
      if(data && data.length > 2 && (this.selected_animal === null || this.selected_animal === "")) {
        // N4: só a fazenda do serviço (sem farm_id o axios omite o parâmetro e a busca segue global)
        this.animals = await this.actionSearchAnimalsGeneral({register:data, farm: this.service && this.service.farm_id});
      }
    },
    addAnimal() {
      if(!this.validations()) return;
      this.$emit("push-animal", this.selected_animal);
      this.selected_animal = "";
      this.animal_group = null;
      this.$emit("close");
    },
    closeModal() {
      this.$emit('close');
    }
  },
  watch: {
    selected_animal(val) {
      if(val && !val.current_birthday_id) {
        this.animalDoesntHasBirth = true;
        this.alertModal = true;
      }
    }
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>